import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "spinner-overlay"
}
const _hoisted_3 = ["id"]
const _hoisted_4 = { class: "ms-table table table-sm" }
const _hoisted_5 = {
  key: 0,
  class: "list"
}
const _hoisted_6 = {
  class: "spare-name",
  nowrap: ""
}
const _hoisted_7 = {
  class: "location",
  nowrap: ""
}
const _hoisted_8 = {
  class: "sub-category",
  nowrap: ""
}
const _hoisted_9 = {
  class: "desc",
  nowrap: ""
}
const _hoisted_10 = {
  class: "ident-number",
  nowrap: "",
  scope: "row"
}
const _hoisted_11 = {
  class: "customer-doc-ref-no",
  nowrap: ""
}
const _hoisted_12 = {
  class: "customer-bar-code",
  nowrap: ""
}
const _hoisted_13 = {
  class: "nkt-bar-code",
  nowrap: ""
}
const _hoisted_14 = { class: "position" }
const _hoisted_15 = { class: "box-pallet-no" }
const _hoisted_16 = { class: "box-pallet-label" }
const _hoisted_17 = { class: "quantity" }
const _hoisted_18 = { class: "unit" }
const _hoisted_19 = { class: "po-ref-noit" }
const _hoisted_20 = {
  class: "delivery-date",
  nowrap: ""
}
const _hoisted_21 = { class: "delivery-cert-no" }
const _hoisted_22 = { class: "manufacturer" }
const _hoisted_23 = {
  class: "last-inspection-by",
  nowrap: ""
}
const _hoisted_24 = {
  class: "last-inspection",
  nowrap: ""
}
const _hoisted_25 = {
  class: "next-inspection",
  nowrap: ""
}
const _hoisted_26 = {
  class: "storage-description",
  nowrap: ""
}
const _hoisted_27 = {
  class: "storage-description",
  nowrap: ""
}
const _hoisted_28 = {
  class: "notes",
  nowrap: ""
}

import { SparePart } from '@/server/MakeSenseApp-backend'
import moment from 'moment'
import { ref, computed } from 'vue'
import '@/styles/ms-table-styles.scss'


export default /*@__PURE__*/_defineComponent({
  __name: 'SparePartsTable',
  props: {
  spareparts: Array<SparePart>,
  isLoading: Boolean,
  idindex: Number
},
  setup(__props) {

const props = __props

const formatTimestamp = (timestamp: Date | undefined): string => {
  if (!timestamp) return '-'
  return moment(timestamp).format('YYYY-MM-DD')
}

const sortKey = ref('sub-category')
const sortOrder = ref<'asc' | 'desc'>('asc')

function toggleSort(key: string) {
  if (sortKey.value === key) {
    sortOrder.value = sortOrder.value === 'asc' ? 'desc' : 'asc'
  } else {
    sortKey.value = key
    sortOrder.value = 'asc'
  }
}

function onHeaderClick(e: MouseEvent) {
  e.preventDefault()
  const th = (e.target as HTMLElement).closest('th[data-sort]') as HTMLElement | null
  if (th?.dataset.sort) toggleSort(th.dataset.sort)
}

const sortedSpareparts = computed(() => {
  return [...(props.spareparts ?? [])].sort((a, b) => {
    switch (sortKey.value) {
      case 'quantity':
        return sortOrder.value === 'asc'
          ? Number(a.quantity ?? 0) - Number(b.quantity ?? 0)
          : Number(b.quantity ?? 0) - Number(a.quantity ?? 0)
      case 'delivery-date':
      case 'expiry-date':
      case 'last-inspection':
      case 'next-inspection': {
        const dateFieldMap: Record<string, string> = {
          'delivery-date': 'deliveryDate',
          'expiry-date': 'expiryDate',
          'last-inspection': 'lastInspection',
          'next-inspection': 'nextInspection'
        }
        const field = dateFieldMap[sortKey.value]
        const aTime = ((a as any)[field] as Date | undefined)?.getTime() ?? 0
        const bTime = ((b as any)[field] as Date | undefined)?.getTime() ?? 0
        return sortOrder.value === 'asc' ? aTime - bTime : bTime - aTime
      }
      default: {
        const strFieldMap: Record<string, string> = {
          'spare-name': 'spareName',
          'location': 'location',
          'sub-category': 'subcategory',
          'desc': 'description',
          'ident-number': 'identity',
          'customer-doc-ref-no': 'customerDocNo',
          'customer-bar-code': 'cusotmerBarCode',
          'nkt-bar-code': 'nktBarCode',
          'position': 'position',
          'box-pallet-no': 'boxPalletNo',
          'box-pallet-label': 'boxPalletLabel',
          'unit': 'unit',
          'po-ref-no': 'poRefeNo',
          'delivery-cert-no': 'deliveryCertNo',
          'Manufacturer': 'manufacturer',
          'last-inspection-by': 'lastInspectionBy',
          'storage-description': 'storageDescription',
          'custom-lead-time': 'customLeadTime',
          'notes': 'notes'
        }
        const field = strFieldMap[sortKey.value] ?? 'spareName'
        const aVal = String((a as any)[field] ?? '')
        const bVal = String((b as any)[field] ?? '')
        const cmp = aVal.localeCompare(bVal)
        return sortOrder.value === 'asc' ? cmp : -cmp
      }
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("div", {
            class: "spinner-border",
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "table-container",
      id: 'table' + __props.idindex
    }, [
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("thead", {
          class: "sticky-header",
          onClick: onHeaderClick
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("tr", null, [
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "spare-name ",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Spare Name ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "location",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Location ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "sub-category",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Subcategory ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "desc",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Description ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "ident-number",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Ident. Number ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "customer-doc-ref-no",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Customer doc/ref no.")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "customer-bar-code",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort"
              }, "Customer Bar code.")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "nkt-bar-code",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "NKT Bar code")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "position",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Position ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "box-pallet-no",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Box/Pallet no.")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "box-pallet-label",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Box/ Pallet Label")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "quantity",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Quantity ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "unit",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Unit ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "po-ref-no",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "PO refrence no.")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "delivery-date",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Delivery Date ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "delivery-cert-no",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Delivery certificate no.")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "Manufacturer",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Manufacturer")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "expiry-date",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Expiry Date ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "last-inspection-by",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Last inspection by ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "last-inspection",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Last inspection ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "next-inspection",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Next inspection ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "storage-description",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Storage Description ")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "custom-lead-time",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Custom Lead Time")
            ]),
            _createElementVNode("th", {
              class: "sort",
              "data-sort": "notes",
              scope: "col"
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "text-body-secondary list-sort sticky-header"
              }, "Notes")
            ])
          ], -1)
        ])),
        (!__props.isLoading)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSpareparts.value, (sparepart, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "ms-row",
                  key: `${sparepart.identity}-${sparepart.position}-${idx}`
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(sparepart.spareName), 1),
                  _createElementVNode("td", _hoisted_7, _toDisplayString(sparepart.location), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(sparepart.subcategory), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(sparepart.description), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(sparepart.identity), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(sparepart.customerDocNo), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(sparepart.cusotmerBarCode), 1),
                  _createElementVNode("td", _hoisted_13, _toDisplayString(sparepart.nktBarCode), 1),
                  _createElementVNode("td", _hoisted_14, _toDisplayString(sparepart.position), 1),
                  _createElementVNode("td", _hoisted_15, _toDisplayString(sparepart.boxPalletNo), 1),
                  _createElementVNode("td", _hoisted_16, _toDisplayString(sparepart.boxPalletLabel), 1),
                  _createElementVNode("td", _hoisted_17, _toDisplayString(sparepart.quantity), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(sparepart.unit), 1),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(sparepart.poRefeNo), 1),
                  _createElementVNode("td", _hoisted_20, _toDisplayString(formatTimestamp(sparepart.deliveryDate)), 1),
                  _createElementVNode("td", _hoisted_21, _toDisplayString(sparepart.deliveryCertNo), 1),
                  _createElementVNode("td", _hoisted_22, _toDisplayString(sparepart.manufacturer), 1),
                  _createElementVNode("td", {
                    class: _normalizeClass(["expiry-date", { 'expired-date-cell': sparepart.isExpired }]),
                    nowrap: ""
                  }, _toDisplayString(sparepart.expiryDate ? formatTimestamp(sparepart.expiryDate) : 'No Limit'), 3),
                  _createElementVNode("td", _hoisted_23, _toDisplayString(sparepart.lastInspectionBy), 1),
                  _createElementVNode("td", _hoisted_24, _toDisplayString(formatTimestamp(sparepart.lastInspection)), 1),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(formatTimestamp(sparepart.nextInspection)), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(sparepart.storageDescription), 1),
                  _createElementVNode("td", _hoisted_27, _toDisplayString(sparepart.customLeadTime), 1),
                  _createElementVNode("td", _hoisted_28, _toDisplayString(sparepart.notes), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ], 8, _hoisted_3)
  ]))
}
}

})